import { css } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Tooltip } from "@/uiKit/atoms/Tooltip.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type HeaderWithTooltipProps = {
  id?: string;
  tooltipContent: string;
  title: string;
};

export const HeaderWithTooltip = ({ id, tooltipContent, title }: HeaderWithTooltipProps) => {
  const styles = useStyles(makeStyles);

  return (
    <Tooltip id={id} placement="top" content={tooltipContent} hover={{ handleClose: null }}>
      <Typography variant="body" className={styles.header}>
        {title}
      </Typography>
    </Tooltip>
  );
};

const makeStyles = (theme: Theme) => ({
  header: css`
    color: ${theme.palette.violet.main};
    text-align: center;
  `,
});
